module.exports = __webpack_public_path__ + "img/verticalIco3.e34b6171.png";